import { z } from "zod";
export const promotionScopeSchema = z.enum(["ALL", "PRODUCT"]);
export const promotionStatusSchema = z.enum([
    "SCHEDULED", "ACTIVE", "ENDED", "DISABLED",
]);
export const promotionInputSchema = z.object({
    name: z.string().trim().min(1, "请输入活动名称").max(100, "活动名称过长"),
    scope: promotionScopeSchema,
    productId: z.string().uuid().nullable().optional(),
    // The percentage is the amount paid: 80 means an 8 折 sale.
    discountPercent: z.number().int().min(1).max(99),
    startsAt: z.string().datetime({ offset: true }),
    endsAt: z.string().datetime({ offset: true }),
}).superRefine((input, context) => {
    if (input.scope === "PRODUCT" && !input.productId) {
        context.addIssue({ code: "custom", path: ["productId"], message: "请选择活动商品" });
    }
    if (input.scope === "ALL" && input.productId) {
        context.addIssue({ code: "custom", path: ["productId"], message: "全场活动不能指定单个商品" });
    }
    if (new Date(input.endsAt).getTime() <= new Date(input.startsAt).getTime()) {
        context.addIssue({ code: "custom", path: ["endsAt"], message: "结束时间必须晚于开始时间" });
    }
});
